import {
    HTTP
} from '../http-common'

import main from './main'

export default {
    state: {
        error: false,
        loading: false,
        reminderYoutvData: [],
        reminderYoutvDialog: false,
        youtvList: [],

    },
    mutations: {
        setYoutvReminderData(state, payload){
            state.reminderYoutvData = payload
        },
        setYoutvReminderDialog(state, payload){
            state.reminderYoutvDialog = payload
        },
        setYoutvList(state, payload) {
            state.youtvList = payload
        },
    },
    actions: {
        youtvBuy({
            commit,
            state,
            dispatch
        }, data) {
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/buy', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        verifyYoutvBuy({
            commit,
            state,
            dispatch
        }, data) {
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/verify-buy', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        getMyYoutvShops({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/youtv/my-shops/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        resendYoutvCODE({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/resend-code', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                        dispatch('setSnackbar', ['info', 'Код активації You TV надіслано повторно'])
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error.response.data.error.message])
                        reject(error)
                    })
            })
        },
        getYoutvCodesByPhone({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/reminder-data', data)
                    .then(response => {
                        state.loading = false
                        commit('setYoutvReminderData', response.data.content)
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        remindeYoutvCode({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/reminde-code', data)
                    .then(response => {
                        state.loading = false
                        commit('setYoutvReminderDialog', false)
                        if(response.data && response.data.content && response.data.content.sended) {
                            dispatch('setSnackbar', ['info', 'Код активації You TV надіслано'])
                        } else {
                            dispatch('setSnackbar', ['error', 'Код активації You TV не надіслано'])
                        }
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        userYoutvClarification
        ({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/user-clarification', data)
                    .then(response => {
                        state.loading = false
                        if (response.data.content && response.data.content.status) {
                            dispatch('setSnackbar', ['info', 'Ваше звернення відправлено'])
                        } else {
                            dispatch('setSnackbar', ['error', 'Будь ласка, вкажіть серійний номер iншого товару'])
                        }
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },       
        youtvList({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                state.loading = true
                HTTP.get('/youtv/list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvList', response.data.content)
                            resolve(response.data.content)
                            state.loading = false
                        } else {
                            commit('setYoutvList', [])
                            resolve([])
                            state.loading = false
                        }
                    })
                    .catch(e => {
                        state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        contractorsAutocomplete({
            commit,
            state
        }, data) {
            return new Promise((resolve, reject) => {
                HTTP.post('/youtv/contractors-autocomplete', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                        } else {
                            resolve([])
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        }
    },   
    
    getters: {
    }
}